import { env } from '@/env'

// Hasura URL: explicit env var (HASURA_GRAPHQL_URL) wins → prod fallback → error
// HASURA_GRAPHQL_URL must be set in .env.local for dev (api.local.nself.org)
// and in Vercel env vars for prod (api.unity.dev). Never guess subdomains.
function getHasuraUrl(): string {
  if (env.HASURA_GRAPHQL_URL) return env.HASURA_GRAPHQL_URL
  if (env.VERCEL_ENV === 'production') return 'https://api.unity.dev/v1/graphql'
  throw new Error('HASURA_GRAPHQL_URL is not set. Add it to .env.local (dev) or Vercel env vars (prod).')
}

export async function hasuraFetch<T = unknown>(
  query: string,
  variables?: Record<string, unknown>,
): Promise<T> {
  const url = getHasuraUrl()
  const secret = env.HASURA_ADMIN_SECRET
  if (!secret) throw new Error('HASURA_ADMIN_SECRET is not set')

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-hasura-admin-secret': secret,
    },
    body: JSON.stringify({ query, variables }),
    cache: 'no-store',
  })

  if (!res.ok) {
    throw new Error(`Hasura HTTP ${res.status}: ${res.statusText}`)
  }

  const json = (await res.json()) as { data?: T; errors?: Array<{ message: string }> }

  if (json.errors?.length) {
    throw new Error(`GraphQL: ${json.errors[0]!.message}`)
  }

  return json.data as T
}

export function toCamel<T>(val: unknown): T {
  if (Array.isArray(val)) return val.map((v) => toCamel(v)) as T
  if (val !== null && typeof val === 'object') {
    return Object.fromEntries(
      Object.entries(val as Record<string, unknown>).map(([k, v]) => [
        k.replace(/_([a-z])/g, (_: string, c: string) => c.toUpperCase()),
        toCamel(v),
      ]),
    ) as T
  }
  return val as T
}
